import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import get from 'lodash/get';
import ListDataPod from '../../../components/ListDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.profiles.placemennt.title',
    defaultMessage: 'Placement',
  },
  clep: {
    id: 'hubs.profiles.placemennt.clep',
    defaultMessage: 'CLEP Subjects',
  },
  international: {
    id: 'hubs.profiles.placemennt.international',
    defaultMessage: 'International Baccalaureate',
  },
  advanced: {
    id: 'hubs.profiles.placemennt.advanced',
    defaultMessage: 'Advanced Placement',
  },
});

function Placement({ placement, intl, lastUpdated }) {
  const list = ['clep', 'international', 'advanced']
    .map(item => {
      const value = get(placement, `${item}.value`);
      return (
        value && {
          text: intl.formatMessage(messages[item]),
          subtext: value,
        }
      );
    })
    .filter(item => item);

  return list.length ? (
    <ListDataPod
      header={intl.formatMessage(messages.title)}
      footer={lastUpdated}
      content={{
        list,
      }}
      className="very-dark-gray"
    />
  ) : null;
}

export default injectIntl(Placement);

Placement.propTypes = {
  lastUpdated: PropTypes.string,
  intl: PropTypes.object,
  placements: PropTypes.object,
};
